import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {CoachingFormComponent} from './coaching-form/coaching-form.component';
import {CoachingTeamComponent} from './coaching-team/coaching-team.component';
import {CoachingReportComponent} from './coaching-report/coaching-report.component';
import {CoachingCommentsComponent} from './coaching-comments/coaching-comments.component';

const routes: Routes = [
    {
        path: 'team',
        component: CoachingTeamComponent
    },
    {
        path: 'my/report/:coachingId',
        component: CoachingReportComponent,
        data: { level: 'learner' }
    },
    {
        path: 'user/:delegateId/report/:coachingId',
        component: CoachingReportComponent,
        data: { level: 'manager' }
    },
    {
        path: 'my/form/new',
        component: CoachingFormComponent,
        data: { level: 'learner', action: 'new' }
    },
    {
        path: 'user/form/new/:delegateId',
        component: CoachingFormComponent,
        data: { level: 'manager', action: 'new' }
    },
    {
        path: 'user/form/edit/:coachingId',
        component: CoachingFormComponent,
        data: { level: 'manager', action: 'edit' }
    },
    {
        path: 'my/comments',
        component: CoachingCommentsComponent,
        data: { level: 'learner' }
    },
    {
        path: 'user/comments/:del_id',
        component: CoachingCommentsComponent,
        data: { level: 'manager' }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class CoachingRoutingModule {
}
